import React from "react"
import {useEffect} from "react"

import {useUserApp} from "@hooks"


export default function LogoutPage() {
	const { handleLogout } = useUserApp()

	useEffect(() => {
		handleLogout()
	}, [])

	return <></>
}